/**
 * @module Store/view
 * @description Module for back
 */

/**
 * @constant State of orders store
 * @type {Object}
 * */
const state = {
    back: undefined
};

/**
 * @constant Getters
 * @type {Object}
 * */
const getters = {
    getBack: state => state.back
};

/**
 * @constant Mutations
 * @type {Object}
 * */
const mutations = {
    setBack: (state, payload) => state.back = payload
};

/**
 * @constant Actions
 * @type {Object}
 * */
const actions = {
    setBack ({commit}, payload) {
        commit('setBack', payload);
    },
    reBack ({store }) {
        return store.back;
    }
};

export default {
    state,
    getters,
    mutations,
    actions
};
